import { Spinner } from '@cian/ui-kit';
import * as React from 'react';

export interface IImageLoadProps {
  src: string;
  alt?: string;
  imgProps?: React.HTMLProps<HTMLImageElement>;
  loaded?: boolean;
  failText?: string;
  style?: React.CSSProperties;
  dataId?: string;

  onLoad?(e: Event): void;
  onError?(e: Event): void;
}

export interface IImageLoadState {
  loaded?: boolean;
  fail?: boolean;
}

export class ImageLoad extends React.Component<IImageLoadProps, IImageLoadState> {
  public imgElement: HTMLImageElement;
  private img: HTMLImageElement;

  public constructor(props: IImageLoadProps) {
    super(props);

    this.state = {
      loaded: props.loaded || false,
    };
  }

  public UNSAFE_componentWillMount() {
    this.img = new Image();
    this.img.addEventListener('load', this.onLoad);
    this.img.addEventListener('error', this.onError);
    this.img.src = this.props.src;
  }

  public UNSAFE_componentWillReceiveProps(nextProps: IImageLoadProps) {
    if (this.props.src !== nextProps.src) {
      this.img.removeEventListener('load', this.onLoad);
      this.img.removeEventListener('error', this.onError);

      this.setState({ loaded: false }, () => {
        this.img = new Image();
        this.img.addEventListener('load', this.onLoad);
        this.img.addEventListener('error', this.onError);
        this.img.src = nextProps.src;
      });
    }
  }

  public componentWillUnmount() {
    this.img.removeEventListener('load', this.onLoad);
    this.img.removeEventListener('error', this.onError);
  }

  public render() {
    if (this.state.loaded) {
      return this.renderCleanImage();
    }

    if (this.state.fail) {
      return this.renderFailImage();
    }

    return this.renderLoadImage();
  }

  private renderCleanImage = () => {
    return (
      <img
        data-id={this.props.dataId}
        ref={el => {
          if (el) {
            this.imgElement = el;
          }
        }}
        onLoad={this.imgNodeLoad}
        src={this.img.src}
        alt={this.props.alt}
        style={this.props.style}
      />
    );
  };

  private renderLoadImage = () => {
    return (
      <span>
        <Spinner />
      </span>
    );
  };

  private renderFailImage = () => {
    return <span>{this.props.failText}</span>;
  };

  private onLoad = () => {
    this.setState({
      loaded: true,
    });
  };

  private imgNodeLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    if (this.props.onLoad) {
      this.props.onLoad(e.nativeEvent);
    }
  };

  private onError = (e: Event) => {
    this.setState(
      {
        fail: true,
        loaded: false,
      },
      () => this.props.onError && this.props.onError(e),
    );
  };
}
